import filterConstants from '../constants';

const userLogs = () => ({
  id: null,
  name: null,
  type: filterConstants.FILTERS.userLogs,
  properties: {
    [filterConstants.PROPERTY.task_name]: '',
    [filterConstants.PROPERTY.gantt_id]: '',
    [filterConstants.PROPERTY.date]: '',
    [filterConstants.PROPERTY.time]: '',
    [filterConstants.PROPERTY.comment]: '',
  },
});

export default userLogs;
